import { render, staticRenderFns } from "./Notifikasi.vue?vue&type=template&id=b57ba252"
import script from "./Notifikasi.vue?vue&type=script&lang=js"
export * from "./Notifikasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports